import { createI18n, I18nOptions } from 'vue-i18n'
import zhCN from '../locales/zh-CN'

export const supportLocales = ['zh-CN', 'zh-TW', 'en-US'] as const
export const defaultLocale = 'zh-CN'

export type MessageSchema = typeof zhCN

export type NumberSchema = {
  decimal: {
    style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 2
  },
  signed: {
    style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 2, signDisplay: 'always'
  },
  usdt: {
    style: 'decimal', minimumFractionDigits: 4, maximumFractionDigits: 4
  },
  currency: {
    style: 'currency',
    currency: 'CNY',
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true
  }
}

const options: I18nOptions = {
  legacy: false,
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  messages: {
    [defaultLocale]: zhCN
  },
  numberFormats: {
    [defaultLocale]: {
      decimal: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      signed: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2, signDisplay: 'always'
      },
      usdt: {
        style: 'decimal', minimumFractionDigits: 4, maximumFractionDigits: 4
      },
      currency: {
        style: 'currency',
        currency: 'CNY',
        currencyDisplay: 'symbol',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: true
      }
    }
  }
}
const i18n = createI18n<false, typeof options>(options)

export default i18n
